<template>
  <div id="bodyOverview">
    <!-- Search -->
    <div id="search">
      <div class="icon"><FontAwesomeIcon icon="search" /></div>
      <input
        type="text"
        placeholder="搜尋商店名稱/ID"
        v-model="accountId"
        @keyup.enter="search()"
      />
      <a class="icon" @click="reset()"><FontAwesomeIcon icon="times"/></a>
    </div>
    <!-- Main -->
    <div id="container" v-if="isInitialize">
      <!-- 出單機 -->
      <div v-if="switchInitial">
          <div class="areaH">
              <div class="areaV">
                  <div class="box"> 
                      <div class="item">
                          <span class="title">分站出單</span>
                          <label class="switch" style="margin-left: 10px;">
                              <input type="checkbox" v-model="data.is_station" @change="updateIsStation()"> <!-- checked -->
                              <span class="slider round"></span>
                          </label>
                      </div>
                  </div>
              </div>
          </div>
      </div>
      <!-- 出單機 -->
      <div id="mainHardware" v-show="data.is_station">
        <div class="areaH">
          <div class="areaV">
            <div class="box" :class="{ editBox: editMode }">
              <!-- class="editBox" **********編輯模式切換********** -->
              <div class="item">
                <span class="title">出單機</span>
                <a class="add" v-if="!editMode" @click="toggleEditMode()"
                  ><FontAwesomeIcon icon="pen"
                /></a>
                <a class="save" v-else @click="printerSave()"
                  ><FontAwesomeIcon icon="save"
                /></a>
                <!-- printers sycronization -->
                <el-dropdown placement="bottom-start" size="mini">
                  <a class="el-dropdown-link" @click="synchronizePrinters()"
                    ><FontAwesomeIcon icon="exclamation-triangle" style="color: red; width:24px; height: 24px;"
                  /></a>
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item disabled>沒有顯示已綁定的出單機嗎？ </el-dropdown-item>
                    <el-dropdown-item disabled>點擊此按鈕同步出單機</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
              </div>
              <div class="item wrap" style="align-items: unset;">
                <div
                  class="hardware"
                  v-for="(printer, index) in printers"
                  :key="'printe' + index"
                >
                  <span class="title">{{printer.type == "label" ? "（標籤機）" : ""}}</span><span v-show="!editMode" :class="{title: true}" :key="'sapn-printer-name' + index">{{ printer.printerName }}</span>
                  <el-input placeholder="出單機名稱" :key="'input-printer-name' + index" v-model="printer.printerName" v-show="editMode"></el-input>
                  <span style="font-weight: bold; color: #a0a0a0">{{ printer.did }}</span>
                  <div class="item wrap">
                    <span class="content" style="margin-right: 5px;"
                      >工作站</span
                    >
                    <div
                      class="station"
                      :class="{ off: !checkIfOriginPrinterExist(printer) }"
                      @click="selectDefaultStation(printer)"
                    >
                      <span class="content">預設（總單）</span>
                    </div>
                    <div
                      class="station"
                      v-for="(station, sIndex) in stations"
                      :key="'station' + sIndex + index"
                      :class="{ off: stationOff(station.id, printer.stations) }"
                      @click="selectStation(printer.printerId, station)"
                    >
                      <span class="content">{{ station.name }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 工作站 -->
      <div id="mainStation" v-show="data.is_station">
        <div class="areaH">
          <div class="areaV">
            <div class="box">
              <div class="item">
                <span class="title">工作站</span>
                <a class="add popStation" @click="addStation()"
                  ><FontAwesomeIcon icon="plus"
                /></a>
              </div>
              <table>
                <tr>
                  <th style="min-width: 30px;">
                    <span class="content">工作站名稱</span>
                  </th>
                  <th><span class="content">列印品項</span></th>
                  <th><span class="content">取餐方式</span></th>
                  <th><span class="content">出單樣板</span></th>
                  <th><span class="content">列印次數</span></th>
                  <th><span class="content">列印金額</span></th>
                  <th></th>
                </tr>
                <tr
                  v-for="(stationSetting, index) in stationSettings"
                  :key="'stationSetting' + index"
                >
                  <td align="center">
                    <span class="content mainColor">{{
                      displayStationName(stationSetting.stationId)
                    }}</span>
                  </td>
                  <td align="center">
                    <span class="content">{{
                      displayStationClasses(stationSetting.stationId)
                    }}</span>
                  </td>
                  <td align="center">
                    <span class="content">TBD</span>
                  </td>
                  <td align="center">
                    <span class="content">TBD</span>
                  </td>
                  <td align="center">
                    <span class="content">{{stationSetting.times}}</span>
                  </td>
                  <td align="center">
                    <span class="content">TBD</span>
                  </td>
                  <td align="center">
                    <div class="action">
                      <a
                        ><FontAwesomeIcon
                          icon="pen"
                          @click="editStation(stationSetting.stationId)"
                      /></a>
                      <a
                        ><FontAwesomeIcon
                          icon="trash"
                          @click="deleteStation(stationSetting.stationId)"
                      /></a>
                    </div>
                  </td>
                </tr>
              </table>
            </div>
          </div>
        </div>
      </div>
      <!-- Popup - 新增/編輯工作站 -->
      <div
        id="popStation"
        class="modal"
        ref="popup-position"
        @click="closePopup($event)"
      >
        <div class="modal-content">
          <span class="close" @click="hidePopupPosition()">&times;</span>
          <span class="title">{{ stationModal.title }}</span>
          <div class="item">
            <span class="content" style="min-width: 72px;">工作站名稱</span>
            <input
              class="input"
              type="text"
              style="margin-left: 10px;"
              placeholder=""
              v-model="stationModal.stationName"
            />
          </div>
          <div class="item">
            <span class="content" style="min-width: 72px;">列印次數</span>
            <div class="number" style="margin-left: 10px;">
              <input type="number" min="0" v-model="stationModal.printTimes"/>
            </div>
          </div>
          <!-- <div class="item">
            <span class="content" style="min-width: 72px;">取餐方式</span>
            <div
              style="width: 100%; display: flex; justify-content: space-between;"
            >
              <label class="check" style="margin-left: 10px;">
                <input type="checkbox" name="checkbox1" checked />
                <span class="checkmark checkbox"></span>
                <div class="text">內用</div>
              </label>
              <label class="check" style="margin-left: 10px;">
                <input type="checkbox" name="checkbox1" />
                <span class="checkmark checkbox"></span>
                <div class="text">自取</div>
              </label>
              <label class="check" style="margin-left: 10px;">
                <input type="checkbox" name="checkbox1" />
                <span class="checkmark checkbox"></span>
                <div class="text">外送</div>
              </label>
            </div>
          </div>
          <div class="item">
            <span class="content">是否列印金額</span>
            <div
              style="width: 100%; height: 40px; display: flex; align-items: center; justify-content: space-between;"
            >
              <label class="switch" style="margin-left: 10px;">
                <input type="checkbox" />
                <span class="slider round"></span>
              </label>
              <a class="question"><FontAwesomeIcon icon="question-circle"/></a>
            </div>
          </div>
          <div class="item">
            <span class="content">是否列印總單</span>
            <div
              style="width: 100%; height: 40px; display: flex; align-items: center; justify-content: space-between;"
            >
              <label class="switch" style="margin-left: 10px;">
                <input type="checkbox" checked />
                <span class="slider round"></span>
              </label>
              <a class="question"><FontAwesomeIcon icon="question-circle"/></a>
            </div>
          </div> -->
          <div class="item">
            <!-- class="gray" -->
            <span class="content" style="min-width: 72px;">列印品項</span>
            <div
              style="width: 100%; height: 40px; margin-left: 10px; display: flex; align-items: center; justify-content: space-between;"
            >
              <span class="content" style="white-space: normal;">{{
                stationModal.displayStationClasses
              }}</span>
              <a
                class="edit popPrint"
                @click="editItemsToBePrint(stationModal.stationId)"
                ><FontAwesomeIcon icon="pen"
              /></a>
            </div>
          </div>
          <!-- <div class="item">
            <span class="content" style="min-width: 72px;">出單樣板</span>
            <div
              style="width: 100%; height: 40px; margin-left: 10px; display: flex; align-items: center; justify-content: space-between;"
            >
              <span class="content">{{ stationModal.template }}</span>
              <a class="edit popReceipt"><FontAwesomeIcon icon="pen"/></a>
            </div>
          </div> -->
          <div class="item">
            <a class="button cancel" @click="hidePopupPosition()">取消</a>
            <a
              v-if="stationModal.stationId"
              class="button submit"
              @click="editStationConfirm()"
              >確定修改</a
            >
            <a v-else class="button submit" @click="addStationConfirm()"
              >確定</a
            >
          </div>
        </div>
      </div>

      <!-- Popup - 列印品項 -->
      <div
        id="popPrint"
        class="modal"
        ref="popup-print"
        @click="closePopup($event)"
      >
        <div class="modal-content">
          <span class="close" @click="hidePopupPrint()">&times;</span>
          <span class="title">列印品項</span>
          <div class="areaH">
            <div class="areaV type">
              <span class="title">屬性</span>
              <label
                :class="{check: true, active: selectedCategorySku == operateClass.sku}"
                v-for="(operateClass, index) in operateClasses"
                :key="'operateClass' + index"
              >
                <input
                  type="checkbox"
                  name="checkbox1"
                  v-model="operateClass.selected"
                />
                <!-- checked-->
                <span class="checkmark checkbox"></span>
                <div class="areaV">
                  <div class="text">{{ operateClass.name }}</div>
                </div>
                <a @click.prevent="generateItemsModal(operateClass.sku)"><FontAwesomeIcon icon="chevron-right"/></a>
              </label>
            </div>
            <div
              class="areaV product active"
              v-if="cartProductsModal.length > 0"
            >
              <!-- class="active" -->
              <span class="title">商品</span>
              <label
                class="check"
                v-for="(cartProduct, index) in cartProductsModal"
                :key="'cartProduct' + index"
              >
                <input
                  type="checkbox"
                  name="checkbox2"
                  v-model="cartProduct.selected"
                  @change="appendTempData(cartProduct.selected)"
                />
                <!-- checked-->
                <span class="checkmark checkbox"></span>
                <div class="areaV">
                  <div class="text">{{ cartProduct.nameList[0] }}</div>
                  <div
                    class="remark"
                    v-for="(name, index) in cartProduct.nameList"
                    :key="'name' + index"
                  >
                    {{ name }}
                  </div>
                </div>
              </label>
            </div>
          </div>
          <div class="item">
            <a
              class="button cancel"
              style="width: 100%;"
              @click="hidePopupPrint()"
              >取消</a
            >
            <a
              class="button submit"
              style="width: 100%;"
              @click="classesAndItemsConfim()"
              >確定</a
            >
          </div>
        </div>
      </div>

      <!-- Popup - 出單樣板 -->
      <div
        id="popReceipt"
        class="modal"
        ref="popup-receipt"
        @click="closePopup($event)"
      >
        <div class="modal-content">
          <span class="close">&times;</span>
          <span class="title">出單樣板</span>
          <div class="areaH">
            <label class="check receipt">
              <input type="radio" name="radio1" checked />
              <!-- checked="checked" -->
              <span class="checkmark radio"></span>
              <div class="item">
                <span class="content">預設模板</span>
              </div>
              <!-- <img src="./img/Receipt1.png" /> -->
            </label>
            <label class="check receipt">
              <input type="radio" name="radio1" />
              <!-- checked="checked" -->
              <span class="checkmark radio"></span>
              <div class="item">
                <span class="content">主商品變小</span>
              </div>
              <!-- <img src="./img/Receipt2.png" /> -->
            </label>
            <label class="check receipt">
              <input type="radio" name="radio1" />
              <!-- checked="checked" -->
              <span class="checkmark radio"></span>
              <div class="item">
                <span class="content">主商品變小<br />加購選項變大</span>
              </div>
              <!-- <img src="./img/Receipt3.png" /> -->
            </label>
            <label class="check receipt">
              <input type="radio" name="radio1" />
              <!-- checked="checked" -->
              <span class="checkmark radio"></span>
              <div class="item">
                <span class="content">加購選項變大</span>
              </div>
              <!-- <img src="./img/Receipt4.png" /> -->
            </label>
          </div>
          <div class="item">
            <a class="button cancel" style="width: 100%;">取消</a>
            <a class="button submit" style="width: 100%;">確定</a>
          </div>
        </div>
      </div>

      <!-- Popup - 通知 -->
      <div id="popDelete" ref="popup-delete" class="modal" @click="closePopup($event)">
          <div class="modal-content">
              <span class="close" @click="hidePopupDelete()">&times;</span>
              <span class="title">刪除工作站？</span>
              <span class="content" style="text-align: center;">刪除前請注意是否已連接工作站</span>
              <div class="item">
                  <a class="button cancel" style="width: 100%;" @click="hidePopupDelete()">取消</a>
                  <a class="button submit" style="width: 100%;" @click="deleteStationConfirm()">確定刪除</a>
              </div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { Dropdown } from 'element-ui';
import axios from "axios";
import Swal from "sweetalert2";
import { fetchSettings } from "src/javascripts/gaa/fetchForConsoleLog";
import {
  updateAccounts,
  updateBusiness,
  updateBusinessInfo,
  updateAccountSSo
} from "src/javascripts/gaa/updateForConsoleLog";

export default {
  components: {
    FontAwesomeIcon,
    Dropdown
  },
  data() {
    return {
      data: {
        is_station: false
      },
      isInitialize: false,
      accountId: null,
      editMode: false,
      printers: [
        // {
        //   printerId: 2,
        //   did: "b4fdec44-0654-416c-95a1-5aa8bce4d49d",
        //   printerName: null,
        //   accountId: 1,
        //   stations: [
        //     { stationId: 1, stationName: "飲料站" },
        //     { stationId: 2, stationName: "甜點站" }
        //   ]
        // },
        // {
        //   printerId: 3,
        //   did: "b4fdec44-0654-416c-95a1-5aa8bce4d49d",
        //   printerName: null,
        //   accountId: 1,
        //   stations: [{ stationId: 3, stationName: "肉" }]
        // }
      ],
      stations: [
        // {
        //   id: 1,
        //   name: "飲料站",
        //   sku: null
        // },
        // {
        //   id: 2,
        //   name: "甜點站",
        //   sku: "dessertSku"
        // },
        // {
        //   id: 3,
        //   name: "肉",
        //   sku: "meatSku"
        // }
      ],
      stationModal: {
        title: "",
        stationName: "",
        printTimes: 1,
        mealType: "TBD",
        isPrintSubtotal: "TBD",
        isPrintDefault: "TBD",
        displayStationClasses: "",
        template: "TBD",
        stationId: ""
      },
      stationSettings: [],
      cartProductClasses: [],
      classModal: {
        classes: [
          {
            sku: "",
            name: "",
            nameList: [],
            selected: false
          }
        ],
        items: []
      },
      operateClasses: [],
      cartProducts: [],
      negativeCartProducts: [],
      resetNegativeCartProductsClasses: [],
      negativeCartProductsTemp: [],
      cartProductsModal: [],
      cartProductsTemp: [],
      originPrinterDidArr: [],
      shopId: "",
      selectedStationIdToBeDelete: "",
      switchInitial: false,
      selectedCategorySku: ""
    };
  },
  created() {
    this.negativeCartProductsTemp = this.negativeCartProducts;
  },
  updated() {},
  methods: {
    change(event) {
      console.log("change event: ", event)
    },
    focus(event, printer) {
      console.log("focus: ", event);
      console.log("focus: ", event.target);
      printer.printerName = "";
    },
    changePrinterName(event, printer) {
      console.log("changePrinterName: ", printer)
      let printerName = event.target.innerText;
      printer.printerName = printerName;
    },
    setData(fetchData) {
      for (var prop in fetchData) {
        if (fetchData[prop] === 1) fetchData[prop] = true;
        if (fetchData[prop] === 0) fetchData[prop] = false;
      }
      console.log("fetchData: ", fetchData);
      this.data = Object.assign(this.data, fetchData);
      console.log("this.data: ", this.data);
      this.switchInitial = true;
    },
    selectDefaultStation(printer) {
      if (!this.editMode) {
        return;
      }
      if (this.checkIfOriginPrinterExist(printer)) {
        let indexOfDid = this.originPrinterDidArr.indexOf(printer.did);
        this.originPrinterDidArr.splice(indexOfDid, 1);
      } else {
        this.originPrinterDidArr.push(printer.did);
      }
    },
    checkIfOriginPrinterExist(printer) {
      console.log("printer: ", printer);
      let originPrinterDidArr = this.originPrinterDidArr;
      if (printer && originPrinterDidArr.includes(printer.did)) {
        return true;
      }
    },
    appendTempData(selected) {
      console.log("selected: ", selected);
      console.log("this.cartProductsModal: ", this.cartProductsModal);
      if (!selected) {
        this.resetNegativeCartProductsClasses = [];
        // find non-selected items in this.cartProductsModal
        let negativeItems = this.cartProductsModal.filter(p => {
          return p.selected == false;
        });
        console.log("negativeItems: ", negativeItems);

        let uniqueNegativeItems = negativeItems.map(item => {
          let { sku, classSku } = item;
          return {
            sku,
            classSku
          };
        });

        if (uniqueNegativeItems.length > 0) {
          // find classSku
          let classSku = uniqueNegativeItems[0].classSku;
          console.log("classSku: ", classSku);

          // delete obj in this.negativeCartProducts filter by classSku

          this.negativeCartProducts = this.negativeCartProducts.filter(
            p => p.classSku != classSku
          );
          console.log("this.negativeCartProducts: ", this.negativeCartProducts);

          // append non-selected items to this.negativeCartProducts
          this.negativeCartProducts = this.negativeCartProducts.concat(
            uniqueNegativeItems
          );
          console.log("this.negativeCartProducts: ", this.negativeCartProducts);
        }
      } else {
        let positiveItems = this.cartProductsModal.filter(p => {
          return p.selected == true;
        });

        let uniquePositiveItems = positiveItems.map(item => {
          let { sku, classSku } = item;
          return {
            sku,
            classSku
          };
        });

        // let positiveSkuArr = uniquePositiveItems.map(p => p.sku);
        // let uniquePositiveSkuArr = Array.from(new Set(positiveSkuArr));

        if (uniquePositiveItems.length > 0) {
          // find classSku

          // remove positive item in this.negativeCartProducts
          this.negativeCartProducts = this.negativeCartProducts.filter(np => {
            return (
              uniquePositiveItems.findIndex(pp => {
                return pp.classSku == np.classSku && np.sku == pp.sku;
              }) == -1
            );
          });
          console.log("this.negativeCartProducts: ", this.negativeCartProducts);

          //
          if (this.negativeCartProducts.length == 0) {
            let positiveClasses = positiveItems.map(pItem => {
              return pItem.classSku;
            });
            console.log("positiveClasses: ", positiveClasses);
            this.resetNegativeCartProductsClasses = this.resetNegativeCartProductsClasses.concat(
              positiveClasses
            );
            console.log(
              "this.resetNegativeCartProductsClasses: ",
              this.resetNegativeCartProductsClasses
            );
          }
        }
      }
      return;
    },
    async generateItemsModal(classSku) {
      this.selectedCategorySku = classSku;
      console.log("generateItemsModal: ", classSku);
      this.cartProductsModal = [];
      // get cartProducts & negativeCartProducts
      await this.callGetCartProductByClassSku(classSku);

      // check temp data
      let tempNegativeCartProducts = this.negativeCartProducts.filter(p => {
        return p.classSku == classSku;
      });
      console.log("tempNegativeCartProducts: ", tempNegativeCartProducts);
      if (tempNegativeCartProducts.length == 0) {
        await this.callGetNegativeCartProductByClassSku(classSku);
      }

      let filterNegativeCartProductsByClassSku = this.negativeCartProducts.filter(
        cartProdcut => cartProdcut.classSku == classSku
      );
      console.log(
        "filterNegativeCartProductsByClassSku: ",
        filterNegativeCartProductsByClassSku
      );
      this.cartProductsModal = this.cartProducts.map(cartProduct => {
        cartProduct.selected =
          filterNegativeCartProductsByClassSku.findIndex(
            p => p.sku == cartProduct.sku
          ) == -1;
        cartProduct.classSku = classSku;
        return cartProduct;
      });
      console.log("this.cartProductsModal: ", this.cartProductsModal);
      return;
    },
    search() {
      let accountId = this.accountId;
      if (accountId) {
        console.log("this.printers: ", this.printers);
        // get printers data
        let getPrintersConfig = {
          url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
            this.accountId
          }/printer-station/printers`,
          method: "GET"
        };
        axios(getPrintersConfig)
          .then(getPrintersRes => {
            console.log("getPrintersRes: ", getPrintersRes);
            // update this.printers
            this.printers = getPrintersRes.data;
            this.isInitialize = true;

            return fetchSettings(this.accountId);
          })
          .then(fetchSettingsRes => {
            if (fetchSettingsRes.data.length > 0) {
              this.setData(fetchSettingsRes.data[0]);
            } else {
              throw new Error("FetchData error!");
            }
          })
          .catch(getPrintersErr => {
            console.log("getPrintersErr: ", getPrintersErr);
            this.$message({
              type: "error",
              message: `商店：${this.accountId} ，無法取得資料！`
            });
          });
        this.getStationList();
        this.getStationSettings();
        this.getCartProductClasses();
        this.getOriginBindingPrinters();
      }
    },
    reset() {
      this.accountId = null;
      this.isInitialize = false;
    },
    getOriginBindingPrinters() {
      let that = this;
      let getOriginBindingPrintersConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/origin-printers`,
        method: "GET"
      };
      axios(getOriginBindingPrintersConfig)
        .then(getOriginBindingPrintersRes => {
          console.log("getOriginBindingPrintersRes: ", getOriginBindingPrintersRes);
          that.originPrinterDidArr = getOriginBindingPrintersRes.data.printers;
          that.shopId = getOriginBindingPrintersRes.data.shopId;
        })
        .catch(getOriginBindingPrintersErr => {
          console.log("getOriginBindingPrintersErr: ", getOriginBindingPrintersErr);
        });
    },
    getCartProductClasses() {
      let that = this;
      let getCartProductClassConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/classes`,
        method: "GET"
      };
      axios(getCartProductClassConfig)
        .then(getCartProductClassRes => {
          console.log("getCartProductClassRes: ", getCartProductClassRes);
          that.cartProductClasses = getCartProductClassRes.data;
        })
        .catch(getStationListErr => {
          console.log("getStationListErr: ", getStationListErr);
        });
    },
    displayOperateTemp(stationId) {
      let foundStationSetting = this.stationSettings.find(
        stationSetting => stationSetting.stationId == stationId
      );
      console.log("foundStationSetting: ", foundStationSetting);
      let stationHasClass = foundStationSetting.stationHasClass;
      console.log("stationHasClass: ", stationHasClass);

      // get all classes
      let allClasses = this.cartProductClasses;
      console.log("allClasses: ", allClasses);

      this.operateClasses = [];

      let operateClasses = allClasses.map(theClass => {
        let sku = theClass.sku;
        let nameList = theClass.nameArr.map(nameObj => {
          return nameObj.name;
        });
        let name = nameList.join(", ");

        let selectedSkuArr = stationHasClass.map(selectedClass => {
          return selectedClass.sku;
        });
        let selected = selectedSkuArr.includes(sku);

        return {
          sku,
          name,
          nameList,
          selected
        };
      });

      console.log("operateClasses: ", operateClasses);

      this.operateClasses = operateClasses;

      let selectedOperateClasses = operateClasses.filter(obj => obj.selected);
      let nameArr = selectedOperateClasses.map(obj => obj.name);
      console.log("nameArr: ", nameArr);

      return nameArr.join(", ");
    },
    getStationList() {
      let that = this;
      let getStationListConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/stations`,
        method: "GET"
      };
      axios(getStationListConfig)
        .then(getStationListRes => {
          console.log("getStationListRes: ", getStationListRes);
          that.stations = getStationListRes.data;
        })
        .catch(getStationListErr => {
          console.log("getStationListErr: ", getStationListErr);
        });
    },
    getStationSettings() {
      let getStationSettingsConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/station/settings`,
        method: "GET"
      };
      axios(getStationSettingsConfig)
        .then(getStationSettingsRes => {
          console.log("getStationSettingsRes: ", getStationSettingsRes);
          this.stationSettings = getStationSettingsRes.data;
          console.log("this.stationSettings: ", this.stationSettings);
        })
        .catch(getStationSettingsErr => {
          console.log("getStationSettingsErr: ", getStationSettingsErr);
        });
    },
    classesAndItemsConfim() {
      console.log("this.operateClasses: ", this.operateClasses);
      let selectedClasses = this.operateClasses.filter(obj => obj.selected);
      let nameArr = selectedClasses.map(obj => obj.name);
      this.stationModal.displayStationClasses = nameArr.join(", ");
      this.negativeCartProductsTemp = this.negativeCartProducts;
      this.hidePopupPrint();
    },
    editStationConfirm() {
      console.log("editStationConfirm: ", this.stationModal);
      let stationName = this.stationModal.stationName;
      let that = this;
      let selectedSkuArr = this.operateClasses
        .filter(operateClass => {
          if (operateClass.selected) return true;
          return false;
        })
        .map(operateClass => operateClass.sku);
      console.log("selectedSkuArr: ", selectedSkuArr);
      // update stations_has_sku_category and sku_category
      let updateData = {
        stationId: this.stationModal.stationId,
        selectedSkuArr
      };
      console.log("updateData: ", updateData);

      // this.callUpdateClassSettings(updateData);
      // this.callUpdateStation();
      // update negative cart products
      // this.callUpdateNegativeCartProducts();

      Promise.all([this.callUpdateClassSettings(updateData), this.callUpdateStation(), this.callUpdateNegativeCartProducts()])
      .then(promiseAllRes => {
        console.log("promiseAllRes: ", promiseAllRes);
        that.getStationSettings();
        that.hidePopupPosition();
        that.editSuccess(promiseAllRes, stationName);
      })
      .catch(that.editError);

      this.hidePopupPosition();
    },
    displayStationName(stationId) {
      let foundStationSetting = this.stationSettings.find(
        stationSetting => stationSetting.stationId == stationId
      );
      return foundStationSetting.stationName;
    },
    displayPrintTimes(stationId) {
      let foundStationSetting = this.stationSettings.find(
        stationSetting => stationSetting.stationId == stationId
      );
      return foundStationSetting.times;
    },
    displayStationClasses(stationId) {
      console.log("stationId: ", stationId);
      let foundStationSetting = this.stationSettings.find(
        stationSetting => stationSetting.stationId == stationId
      );
      console.log("foundStationSetting: ", foundStationSetting);

      let classObjArr = foundStationSetting.stationHasClass;
      if (classObjArr.length > 0) {
        let classNameArr = [];
        classObjArr.forEach(stationHasClassObj => {
          stationHasClassObj.classes.forEach(classObj => {
            classNameArr.push(classObj.className);
          });
        });
        console.log("classNameArr: ", classNameArr);
        return classNameArr.join(", ");
      } else {
        return "";
      }
    },
    stationOff(id, printerStations) {
      let stations = printerStations.map(printerStation => {
        return printerStation.stationId;
      });
      return !stations.includes(id);
    },
    selectStation(printerId, station) {
      if (!this.editMode) {
        return;
      }
      let that = this;
      function remoteStation(formatStation, foundPrinter, foundIndex) {
        let foundStationIndex = foundPrinter.stations.findIndex(
          station => station.stationId == formatStation.stationId
        );
        foundPrinter.stations.splice(foundStationIndex, 1);
        that.printers.splice(foundIndex, 1, foundPrinter);
      }
      function addStation(formatStation, foundPrinter, foundIndex) {
        foundPrinter.stations.push(formatStation);
        that.printers.splice(foundIndex, 1, foundPrinter);
      }
      function checkIfStationSelected(formatStation, foundPrinter) {
        let stationId = formatStation.stationId;
        let selectedStations = foundPrinter.stations;
        let selectedStationIdArr = selectedStations.map(
          sStation => sStation.stationId
        );
        return selectedStationIdArr.includes(stationId);
      }

      let { id, name } = station;
      let formatStation = {
        stationId: id,
        stationName: name
      };
      let foundPrinter = this.printers.find(
        printer => printer.printerId == printerId
      );
      let foundIndex = this.printers.findIndex(
        printer => printer.printerId == printerId
      );

      if (this.checkIfStationSelected(formatStation, foundPrinter)) {
        remoteStation(formatStation, foundPrinter, foundIndex);
      } else {
        addStation(formatStation, foundPrinter, foundIndex);
      }
      return;
    },
    toggleEditMode() {
      this.getStationList();
      this.editMode = !this.editMode;
      return;
    },
    checkIfStationSelected(formatStation, foundPrinter) {
      let stationId = formatStation.stationId;
      let selectedStations = foundPrinter.stations;
      let selectedStationIdArr = selectedStations.map(
        sStation => sStation.stationId
      );
      return selectedStationIdArr.includes(stationId);
    },
    printerSave() {
      console.log("saved!");
      this.toggleEditMode();
      Promise.all([this.callUpdatePrinters(), this.callUpdataOriginBindingPrinters()])
      .then(promiseAllRes => {
        console.log("promiseAllRes: ", promiseAllRes);
        this.editSuccess(promiseAllRes, "出單機");
      })
      .catch(this.editError);
    },
    addStation() {
      Object.assign(this.stationModal, {
        title: "新增工作站",
        stationName: `新工作站${this.stationSettings.length+1}`,
        displayStationClasses: "",
        stationId: null
      });
      this.addStationConfirm();
      // this.displayPopupPosition();
    },
    addStationConfirm() {
      this.callCreateStation();
    },
    editStation(stationId) {
      this.resetDataWhenStationClick();
      Object.assign(this.stationModal, {
        title: "編輯工作站",
        stationName: this.displayStationName(stationId),
        displayStationClasses: this.displayOperateTemp(stationId),
        printTimes: this.displayPrintTimes(stationId),
        stationId: stationId
      });
      console.log("this.stationModal: ", this.stationModal);

      this.displayPopupPosition();
    },
    deleteStation(stationId) {
      console.log("deleteStation");
      let that = this;
      let popNotice = this.$refs.popNotice;
      console.log(popNotice)
      this.selectedStationIdToBeDelete = stationId;
      this.displayPopupDelete();
      // Swal.fire({
      //   title: "確定要刪除嗎？",
      //   text: "",
      //   icon: "warning",
      //   showCancelButton: true,
      //   confirmButtonColor: "#3085d6",
      //   cancelButtonColor: "#d33",
      //   confirmButtonText: "刪除"
      // }).then(result => {
      //   if (result.isConfirmed) {
      //     that.callDeleteStation(stationId);
      //   }
      // });
    },
    deleteStationConfirm() {
      let stationId = this.selectedStationIdToBeDelete;
      this.hidePopupDelete();
      this.callDeleteStation(stationId);
    },
    editItemsToBePrint(stationId) {
      let foundStationSetting = this.stationSettings.find(
        stationSetting => stationSetting.stationId == stationId
      );
      let stationHasClass = foundStationSetting.stationHasClass;
      console.log("stationHasClass: ", stationHasClass);

      // get all classes
      let allClasses = this.cartProductClasses;
      console.log("allClasses: ", allClasses);

      this.operateClasses = [];

      let operateClasses = allClasses.map(theClass => {
        let sku = theClass.sku;
        let nameList = theClass.nameArr.map(nameObj => {
          return nameObj.name;
        });
        let name = nameList.join(", ");

        let selectedSkuArr = stationHasClass.map(selectedClass => {
          return selectedClass.sku;
        });
        let selected = selectedSkuArr.includes(sku);

        return {
          sku,
          name,
          nameList,
          selected
        };
      });

      console.log("operateClasses: ", operateClasses);

      this.operateClasses = operateClasses;

      this.displayPopupPrint();
    },
    displayPopupPosition() {
      let popupPosition = this.$refs["popup-position"];
      popupPosition.setAttribute("style", "display: flex;");
    },
    displayPopupPrint() {
      let popupPrint = this.$refs["popup-print"];
      popupPrint.setAttribute("style", "display: flex;");
    },
    displayPopupReceipt() {
      let popupReceipt = this.$refs["popup-receipt"];
      popupReceipt.setAttribute("style", "display: flex;");
    },
    displayPopupDelete() {
      let popupDelete = this.$refs["popup-delete"];
      popupDelete.setAttribute("style", "display: flex;");
    },
    hidePopup() {
      let popupPosition = this.$refs["popup-position"];
      let popupPrint = this.$refs["popup-print"];
      let popupReceipt = this.$refs["popup-receipt"];
      let popupDelete = this.$refs["popup-delete"];
      popupPosition.setAttribute("style", "display: none;");
      popupPrint.setAttribute("style", "display: none;");
      popupReceipt.setAttribute("style", "display: none;");
      popupDelete.setAttribute("style", "display: none;");
    },
    hidePopupPosition() {
      let popupPosition = this.$refs["popup-position"];
      popupPosition.setAttribute("style", "display: none;");
    },
    hidePopupPrint() {
      let popupPrint = this.$refs["popup-print"];
      popupPrint.setAttribute("style", "display: none;");
      this.resetDataWhenPrintClose();
    },
    hidePopupReceipt() {
      let popupReceipt = this.$refs["popup-receipt"];
      popupReceipt.setAttribute("style", "display: none;");
    },
    hidePopupDelete() {
      let popupDelete = this.$refs["popup-delete"];
      popupDelete.setAttribute("style", "display: none;");
    },
    closePopup(event) {
      let className = event.target.className;
      if (typeof className != "string") return;
      // if (className.includes("cancel")) {
      //   this.hidePopup();
      //   return;
      // }
      // if (className.includes("close")) {
      //   this.hidePopup();
      //   return;
      // }

      switch (event.target.id) {
        case "popStation":
          this.hidePopupPosition();
          break;
        case "popPrint":
          this.hidePopupPrint();

          break;
        case "popReceipt":
          this.hidePopupReceipt();

          break;
        case "popDelete":
          this.hidePopupDelete();
          break;

        default:
          break;
      }
      return;
    },
    callDeleteStation(stationId) {
      let that = this;
      let deleteStationConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/stations/${stationId}`,
        method: "delete"
      };
      axios(deleteStationConfig)
        .then(deleteStationRes => {
          console.log("deleteStationRes: ", deleteStationRes);
          that.getStationSettings();
        })
        .catch(deleteStationErr => {
          console.log("deleteStationErr: ", deleteStationErr);
        });
    },
    callCreateStation() {
      let stationData = {
        name: this.stationModal.stationName
      };
      let createStationConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/station`,
        method: "POST",
        data: {
          stationData
        }
      };
      let that = this;
      axios(createStationConfig)
        .then(createStationRes => {
          console.log("createStationRes: ", createStationRes);
          that.getStationSettings();
          that.hidePopupPosition();
        })
        .catch(createStationErr => {
          console.log("createStationErr: ", createStationErr);
        });
    },
    callUpdateStation() {
      let stationData = {
        name: this.stationModal.stationName,
        times: this.stationModal.printTimes
      };
      let updateStationConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/stations/${this.stationModal.stationId}`,
        method: "patch",
        data: {
          stationData
        }
      };
      let that = this;
      return axios(updateStationConfig)
        .then(updateStationRes => {
          console.log("updateStationRes: ", updateStationRes);
          that.getStationSettings();
          that.hidePopupPosition();
        })
        .catch(createStationErr => {
          console.log("createStationErr: ", createStationErr);
        });
    },
    callUpdatePrinters() {
      let updatePrintersConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/printers`,
        method: "POST",
        data: {
          data: this.printers
        }
      };
      return axios(updatePrintersConfig)
        // .then(updatePrintersRes => {
        //   return 
        //   console.log("updatePrintersRes: ", updatePrintersRes);
        // })
        // .catch(updatePrintersErr => {
        //   console.log("updatePrintersErr: ", updatePrintersErr);
        // });
    },
    callUpdateClassSettings(data) {
      let that = this;
      let updateClassConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/classes`,
        method: "POST",
        data: data
      };
      return axios(updateClassConfig)
        // .then(updateClassRes => {
        //   console.log("updateClassRes: ", updateClassRes);
        //   that.getStationSettings();
        // })
        // .catch(updateClassErr => {
        //   console.log("updateClassErr: ", updateClassErr);
        // });
    },
    async callGetCartProductByClassSku(classSku) {
      let that = this;
      let getCartProductByClassSkuConfig = {
        url: `${
          process.env.VUE_APP_APIHOST
        }/gaa/class-sku/${classSku}/products`,
        method: "GET"
      };
      return axios(getCartProductByClassSkuConfig)
        .then(getCartProductByClassSkuRes => {
          console.log(
            "getCartProductByClassSkuRes: ",
            getCartProductByClassSkuRes
          );
          that.cartProducts = getCartProductByClassSkuRes.data;
          return;
        })
        .catch(updateClassErr => {
          console.log("updateClassErr: ", updateClassErr);
          return;
        });
    },
    async callGetNegativeCartProductByClassSku(classSku) {
      let that = this;
      let getNegativeCartProductByClassSkuConfig = {
        url: `${
          process.env.VUE_APP_APIHOST
        }/gaa/class-sku/${classSku}/negative-products`,
        method: "GET"
      };
      return axios(getNegativeCartProductByClassSkuConfig)
        .then(getNegativeCartProductByClassSkuRes => {
          console.log(
            "getNegativeCartProductByClassSkuRes: ",
            getNegativeCartProductByClassSkuRes
          );
          let tempNegativeCartProducts = that.negativeCartProducts.filter(
            p => p.classSku == classSku
          );
          if (tempNegativeCartProducts.length == 0) {
            that.negativeCartProducts = that.negativeCartProducts.concat(
              getNegativeCartProductByClassSkuRes.data
            );
          }
          return;
        })
        .catch(updateClassErr => {
          console.log("updateClassErr: ", updateClassErr);
          return;
        });
    },
    callUpdateNegativeCartProducts() {
      let negativeCartProducts = this.negativeCartProducts;
      let resetNegativeCartProductsClasses = this
        .resetNegativeCartProductsClasses;
      console.log("negativeCartProducts: ", negativeCartProducts);
      let that = this;
      let updateNegativeProductConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/negative-products`,
        method: "POST",
        data: {
          negativeCartProducts,
          resetNegativeCartProductsClasses
        }
      };
      axios(updateNegativeProductConfig)
        .then(updateNegativeProductRes => {
          console.log("updateNegativeProductRes: ", updateNegativeProductRes);
        })
        .catch(updateClassErr => {
          console.log("updateClassErr: ", updateClassErr);
        });
    },
    callUpdataOriginBindingPrinters() {
      console.log("callUpdataOriginBindingPrinters ")
      let that = this;
      let callUpdataOriginBindingPrintersConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          this.accountId
        }/printer-station/origin-printers`,
        method: "POST",
        data: {
          originPrinterDidArr: that.originPrinterDidArr,
          shopId: that.shopId
        }
      };
      return axios(callUpdataOriginBindingPrintersConfig)
        // .then(callUpdataOriginBindingPrintersRes => {
        //   console.log("callUpdataOriginBindingPrintersRes: ", callUpdataOriginBindingPrintersRes);
        // })
        // .catch(callUpdataOriginBindingPrintersErr => {
        //   console.log("callUpdataOriginBindingPrintersErr: ", callUpdataOriginBindingPrintersErr);
        // });
    },
    resetDataWhenPrintClose() {
      this.negativeCartProducts = this.negativeCartProductsTemp;
      this.cartProductsModal = [];
    },
    resetDataWhenStationClick() {
      this.negativeCartProducts = [];
    },
    toggleSwitch() {
      let updateBooleanData = {
        key: event.code,
        value: event.mutation,
        dbTable: event.dbTable,
        label: event.name,
        type: event.type
      };
      this.edit(updateBooleanData);
    },
    edit(data) {
      console.log("something-wrong: ");
      let label = data.label;
      if (data.key === "name") data.dbTable = "accounts&business";
      switch (data.dbTable) {
        case "accounts":
          updateAccounts(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business":
          updateBusiness(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "business_info":
          updateBusinessInfo(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "accounts&business":
          updateAccounts(data, this.accountId)
            .then(res => updateBusiness(data, this.accountId))
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        case "account_sso":
          let fields = Object.assign(
            {},
            {
              name: this.data.name,
              accountId: this.accountId,
              appId: data.value
            }
          );
          Object.assign(data, {
            fields: fields
          });
          console.log("data: ", data);
          updateAccountSSo(data, this.accountId)
            .then(res => {
              this.editSuccess(res, label);
            })
            .catch(this.editError);
          break;
        default:
          console.log("undefined db talbe: " + data.dbTable);
          break;
      }
    },
    updateIsStation() {
      console.log(this.accountId);
      console.log(this.data.is_station);
      let updateBooleanData = {
        key: 'is_station',
        value: this.data.is_station,
        dbTable: 'business',
        label: '分站出單',
        type: 'boolean'
      };
      this.edit(updateBooleanData);
    },
    synchronizePrinters() {
      let that = this;
      let synchronizePrintersConfig = {
        url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
          that.accountId
        }/printer-station/printers`,
        method: 'patch',
        data: {
          shopId: that.shopId
        }
      }

      axios(synchronizePrintersConfig)
        .then(synchronizePrintersRes => {
          console.log('synchronizePrintersRes', synchronizePrintersRes);
          let getPrintersConfig = {
            url: `${process.env.VUE_APP_APIHOST}/gaa/accounts/${
              this.accountId
            }/printer-station/printers`,
            method: "GET"
          };
          return axios(getPrintersConfig);
        })
        .then(getPrintersRes => {
          that.printers = getPrintersRes.data;
          console.log('getPrintersRes', getPrintersRes);
          this.$message({
            type: "success",
            message: `同步成功！`
          });
        })
        .catch(synchronizePrintersErr => {
          console.log('synchronizePrintersErr', synchronizePrintersErr);
          this.$message({
            type: "error",
            message: "同步失敗"
          });
        });
    },
    editSuccess(res, label) {
      console.log(res);
      this.$message({
        type: "success",
        message: `${label} 修改成功！`
      });
      this.$emit("saved", true);
    },
    editError(err) {
      console.log(err);
      this.$message({
        type: "error",
        message: "修改失敗"
      });
    }
  },
  watch: {
    accountId: function(val, old) {
      if (!val) {
        this.isInitialize = false;
      }
    }
  }
};
</script>
<style scoped src="../../../../src/assets/css/printer-station.css"></style>
<style scoped>
.printer-name-input {
    min-height: 40px;
    background-color: white;
    border-radius: 5px;
}
</style>